// extracted by mini-css-extract-plugin
export default {"Karyogram":"Karyogram_Karyogram__CTO4E","KaryogramRow":"Karyogram_KaryogramRow__LyoYk","separator":"Karyogram_separator__g7nZ1"};